export default __webpack_public_path__ + "static/media/home-background.49c4c1a3.png";